const validCalleeObjects = new Set(['this', 'event', 'console']);

export default validCalleeObjects;